var config = {
  AMBULANCE_URL: process.env.VUE_APP_AMBULANCE_URL,
  checkboxColor: process.env.VUE_APP_CHECK_BOX_COLOR,
  BASE_URL: process.env.VUE_APP_BASE_URL,
  NEW_BASE_URL: process.env.VUE_APP_NEW_BASE_URL,
  BLOODBANK_URL: process.env.VUE_APP_BLOODBANK_URL,
  HOSPITAL_URL: process.env.VUE_APP_HOSPITAL_URL,
  SUBSCRIPTION_MICROSERVICE_URL: process.env.VUE_APP_SUBSCRIPTION_MICRO_SERVICE_URL,
  USER_AUTH_URL: process.env.VUE_APP_USER_AUTH,
  STAFF_FRONTEND: process.env.VUE_APP_STAFF_FRONTEND,
  PHARMACY_URL: process.env.VUE_APP_PHARMACY_URL,
  PHP_LOCAL: process.env.VUE_APP_PHP_LOCAL_URL,
  DIAGNOSTICS_URL: process.env.VUE_APP_DIAGNOSTICS_URL,
  RECORD_PER_PAGE: process.env.VUE_APP_RECORD_PER_PAGE,
  env: process.env.NODE_ENV,
  MAP_API_KEY: process.env.VUE_MAP_API_KEY,
  FIREBASE_API_KEY: process.env.VUE_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_DB_URL: process.env.VUE_APP_FIREBASE_DB_URL,
  TRANSPORT_URL: process.env.VUE_APP_TRANSPORT_URL,
  ACCOUNTS_API_URL: process.env.VUE_APP_ACCOUNTS_API_URL,
  RAZORPAY_ID: process.env.VUE_APP_RAZORPAY_ID,
  ACCOUNTS_FE_URL: process.env.VUE_APP_ACCOUNTS_FE_URL,
  APP_URL: process.env.VUE_APP_URL,
  ANDROID_URL: process.env.VUE_APP_ANDROID_URL,
  IOS_URL: process.env.VUE_APP_IOS_URL,
  VIDEO_URL: process.env.VUE_APP_VIDEO_URL || "http://localhost:3000",
  S3_BUCKET: process.env.VUE_APP_S3_BUCKET_NAME,
  GOOGLE_ANALYTICS_TRACKER_ID: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKER_ID,
  NUXT_URL: process.env.VUE_APP_NUXT_URL || "http://localhost:3000/",
  NUXT_BLOG_URL: process.env.VUE_APP_NUXT_BLOG_URL || "http://localhost:3003/",
  TEST_MODE: process.env.VUE_APP_TEST_MODE === "true",
  VUE_APP_VENDOR_URL: process.env.VUE_APP_VENDOR_URL,
  BLOG_ENABLED: process.env.VUE_APP_BLOG_ENABLED === "true",
  EVENT_ENABLED: process.env.VUE_APP_CME_EVENT_ENABLED === "true",
  VENDOR_ENABLED: process.env.VUE_APP_VENDOR_ENABLED === "true",
  SUBSCRIPTION_ENABLED: process.env.VUE_APP_SUBSCRIPTION === "true",
  FACEBOOK_PIXEL_KEY: process.env.VUE_APP_FACEBOOK_PIXEL_KEY,
  GOOGLE_AD_WORDS_KEY: process.env.VUE_APP_GOOGLE_AD_WORDS_KEY, 
  G_MAP_API_KEY: process.env.VUE_APP_MAP_API_KEY,
  CENTER_ORDERS_BOOKINGS_API: process.env.VUE_APP_CENTER_ORDERS_BOOKINGS_API,
  HOSPITAL_FE_URL: process.env.VUE_APP_HOSPITAL_FE_URL,
  NUXT_FE_COC_URL: process.env.VUE_APP_NUXT_FE_COC_URL,
  VUE_APP_COC_URL: process.env.VUE_APP_COC_URL,
  VENDOR_LOGIN_PATH: process.env.VUE_APP_VENDOR_LOGIN_PATH,
  CENTER_BOOKING_MANAGEMENT:
  process.env.VUE_APP_CENTER_BOOKING_MANAGEMENT,
};

module.exports = config;
